const o = "'Lato', sans-serif";
export {
  o as lato
};
